// Bridge between server-provided page breadcrumbs (passed to shared/AppPage) and the
// app shell header (shared/AppShell). They are separate react-rails roots with no
// shared context, so AppPage *publishes* its breadcrumbs and the header *subscribes*,
// rendering them (with their real URLs) in place of the nav-derived crumb.

export const HUB_BREADCRUMB_EVENT = 'hub:breadcrumbs';

// Called by a page (AppPage) to hand its breadcrumb trail to the header. Pass null
// to clear. Stored on window too so a late-mounting header can read the current value.
export function publishBreadcrumbs(crumbs) {
  if (typeof window === 'undefined') return undefined;
  const value = Array.isArray(crumbs) && crumbs.length ? crumbs : null;
  window.__HUB_BREADCRUMBS__ = value;
  window.dispatchEvent(new CustomEvent(HUB_BREADCRUMB_EVENT, { detail: value }));
  return value;
}

export function readBreadcrumbs() {
  if (typeof window === 'undefined') return null;
  return window.__HUB_BREADCRUMBS__ || null;
}
